export class ArrayUtil {
  public static flatten = (accumulator: any[], currentValue: any[]) =>
    accumulator.concat(currentValue);
}
